import { useEffect, useState } from "react";

interface ScoreGaugeProps {
  score: number;
}

export const ScoreGauge = ({ score }: ScoreGaugeProps) => {
  const [displayScore, setDisplayScore] = useState(0);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setDisplayScore(score);
    }, 300);
    return () => clearTimeout(timer);
  }, [score]);
  
  const getColor = (score: number) => {
    if (score <= 3) return "text-destructive";
    if (score <= 7) return "text-warning";
    return "text-success";
  };
  
  const getLabel = (score: number) => {
    if (score <= 3) return "Początkujący";
    if (score <= 7) return "Średniozaawansowany";
    return "Ekspert";
  };
  
  const rotation = ((displayScore - 1) / 9) * 180 - 90;
  
  return (
    <div className="flex flex-col items-center py-4">
      <div className="relative w-64 h-40 mb-4">
        {/* Semi-circle background */}
        <svg className="w-full h-full" viewBox="0 0 200 120" preserveAspectRatio="xMidYMid meet">
          <path
            d="M 10 100 A 80 80 0 0 1 190 100"
            fill="none"
            stroke="hsl(var(--secondary))"
            strokeWidth="12"
            strokeLinecap="round"
          />
          {/* Low section (red) */}
          <path
            d="M 10 100 A 80 80 0 0 1 70 30"
            fill="none"
            stroke="hsl(var(--destructive))"
            strokeWidth="12"
            strokeLinecap="round"
            opacity="0.3"
          />
          {/* Mid section (orange) */}
          <path
            d="M 70 30 A 80 80 0 0 1 130 30"
            fill="none"
            stroke="hsl(var(--warning))"
            strokeWidth="12"
            strokeLinecap="round"
            opacity="0.3"
          />
          {/* High section (green) */}
          <path
            d="M 130 30 A 80 80 0 0 1 190 100"
            fill="none"
            stroke="hsl(var(--success))"
            strokeWidth="12"
            strokeLinecap="round"
            opacity="0.3"
          />
          {/* Animated progress */}
          <path
            d="M 10 100 A 80 80 0 0 1 190 100"
            fill="none"
            stroke="hsl(var(--primary))"
            strokeWidth="12"
            strokeLinecap="round"
            strokeDasharray="251.2"
            strokeDashoffset={251.2 - (251.2 * (displayScore - 1)) / 9}
            style={{ transition: "stroke-dashoffset 2s ease-out" }}
          />
        </svg>
        
        {/* Center score display */}
        <div className="absolute inset-0 flex items-end justify-center pb-4">
          <div className="text-center">
            <div className={cn("text-5xl font-bold transition-colors duration-500", getColor(score))}>
              {displayScore}
            </div>
            <div className="text-sm text-muted-foreground">/ 10</div>
          </div>
        </div>
      </div>
      
      <div className="text-center">
        <div className={cn("text-xl font-semibold mb-1", getColor(score))}>
          {getLabel(score)}
        </div>
        <p className="text-sm text-muted-foreground">
          Poziom gotowości LinkedIn
        </p>
      </div>
    </div>
  );
};

function cn(...classes: (string | boolean | undefined)[]) {
  return classes.filter(Boolean).join(' ');
}
